import React from "react";
import BackButton from "../../main/BackButton";
import Video from "../../main/Video";

const FashionShow = () => {
  return (
    <>
      <BackButton url="/allvideos" />
      <Video
        url={`https://yuriy-dmytrash19.wistia.com/medias/9nx9ag149t`}
        maxHeight="80%"
      />
    </>
  );
};

export default FashionShow;
